import get from 'lodash/get';
import { useCallback, useEffect, useState } from 'react';

import { useSafeResizeEventListener } from 'web-ui-kit/hooks';
import { QUERY_FOR_TABLET_LANDSCAPE_BELOW } from 'web-ui-kit/media';
import { navigateToStudioSpaceAndDesignFor } from 'services/routing';

/**
 * Handle Studio Products View Back button config.
 * When the products are displayed and viewport width is phone/tablet,
 * we want to replace the Modsy Logo in the header nav
 * with a Back button that when clicked returns to the studio view.
 */
export default function useStudioBackButton ({
  activeSpace = {},
  designId = null,
  dispatchSetLayoutModalActive = () => {},
  history = {},
  layoutModalActive = false,
  spaceId = null
} = {}) {
  const [backButtonEnabled, setBackButtonEnabled] = useState(false);

  const path = get(history, 'location.pathname', '');
  const isProductViewPage = path.includes('products') || path.includes('hotspot');
  const isDesignNotePage = path.includes('design-notes');
  const isFavoriteProductPage = path.includes('favorites');
  const isPageWithBackButtonNeeded = isProductViewPage || isDesignNotePage || isFavoriteProductPage || layoutModalActive;

  const updateBackButtonConfig = useCallback(() => {
    const isBackButtonEnabled = !!(
      isPageWithBackButtonNeeded &&
      window.matchMedia(QUERY_FOR_TABLET_LANDSCAPE_BELOW).matches
    );

    setBackButtonEnabled(isBackButtonEnabled);
  }, [setBackButtonEnabled, isPageWithBackButtonNeeded]);

  useEffect(updateBackButtonConfig, [setBackButtonEnabled, isPageWithBackButtonNeeded]);

  useSafeResizeEventListener({
    listen: isPageWithBackButtonNeeded,
    onResize: updateBackButtonConfig
  });

  const backButtonConfig = {
    enabled: backButtonEnabled,
    text: 'Back',
    handleClick: () => {
      if (layoutModalActive) {
        dispatchSetLayoutModalActive(false);
      }
      navigateToStudioSpaceAndDesignFor({
        spaceId,
        designId,
        viewType: path.includes('shared') ? 'shared' : '',
        doNotScrollTop: true
      });
    }
  };

  return {
    backButtonConfig
  };
}
